<div class="unauth-footer">
    <div class="d-flex justify-content-end flex-row">
        <div class="navigation">
            <div class="navitems">
                @if (appConfig.languageSwitcher) {
                    @for (language of availableLanguages; track language.code) {
                        <div class="navitem">
                            <a
                                class="has-pointer"
                                (click)="changeLanguage(language.code)"
                                >{{ language.label }}</a
                            >
                        </div>
                    }
                }

                <div class="navitem">
                    <a
                        href="https://www.gs1-germany.de/impressum/"
                        target="_blank"
                        >{{ 'GENERAL.IMPRINT' | translate }}</a
                    >
                </div>
                <div class="navitem">
                    <a
                        href="https://www.gs1-germany.de/datenschutz/"
                        target="_blank"
                        >{{ 'GENERAL.PRIVACY_POLICY' | translate }}</a
                    >
                </div>
                <div class="navitem">
                    <a
                        href="https://orders.gs1-germany.de/fileadmin/gs1/agb/Cloud4Log_AGB_inkl_Anlagen_01.01.2026.pdf"
                        target="_blank"
                        >{{ 'GENERAL.AGB' | translate }}</a
                    >
                </div>
                <div class="navitem">
                    <a
                        class="has-pointer"
                        routerLink="/licenses"
                        >{{ 'GENERAL.LICENSES' | translate }}</a
                    >
                </div>
                <div
                    class="navitem"
                    [matTooltip]="versionString()"
                    matTooltipClass="tw-whitespace-pre-line tw-max-w-[320px]">
                    <span>{{ 'GENERAL.VERSION' | translate }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
